import React from 'react';
export function useDetectOutsideClick(onClick, ref, isModalOpen) {
    React.useEffect(function () {
        var handleClick = function (e) {
            if (ref.current && !ref.current.contains(e.target) && isModalOpen) {
                onClick(null);
            }
        };
        if (ref.current) {
            document.addEventListener('mousedown', handleClick);
            return function () { return document.removeEventListener('mousedown', handleClick); };
        }
    }, [onClick, ref, isModalOpen]);
}
//# sourceMappingURL=useDetectOutsideClick.js.map